<div class="setting-page">
  <legend>Analytics</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit" [hidden]="!isAnalyticsEnabled">
    <arm-form-title>Analytics</arm-form-title>
    <div class="settings-section">

      <mat-form-field class="fullWidth">
        <mat-label>User name</mat-label>
        <input [(ngModel)]="analyticsConfiguration.userName" matInput name="username" disabled>
      </mat-form-field>

      <mat-form-field class="fullWidth">
        <mat-label>Password</mat-label>
        <input autocomplete="new-password" type="password" matInput [(ngModel)]="analyticsConfiguration.password" name="password" pattern="^[^,;\\]+$">
        <mat-error><strong>Invalid</strong> password pattern (',' ';' '\' are not allowed)</mat-error>
      </mat-form-field>

      <mat-form-field class="fullWidth">
        <mat-label>1st Host</mat-label>
        <input [(ngModel)]="analyticsConfiguration.host1" matInput name="host1" pattern="^[^,;']+$">
        <mat-error><strong>Invalid</strong> host pattern (',' ';' ''' are not allowed)</mat-error>
      </mat-form-field>


      <mat-form-field class="fullWidth">
        <mat-label>2nd Host</mat-label>
        <input [(ngModel)]="analyticsConfiguration.host2" matInput name="host2" pattern="^[^,;']+$">
        <mat-error><strong>Invalid</strong> host pattern (',' ';' ''' are not allowed)</mat-error>
      </mat-form-field>

      <mat-form-field class="fullWidth">
        <mat-label>3rd Host</mat-label>
        <input [(ngModel)]="analyticsConfiguration.host3" matInput name="host3" pattern="^[^,;']+$">
        <mat-error><strong>Invalid</strong> host pattern (',' ';' ''' are not allowed)</mat-error>
      </mat-form-field>

    </div>
  </arm-form>
</div>
